/*
 * Gọi block tin của CMS. Khi có header X-Requested-With, server trả CHUỖI JSON chứa HTML
 * (vd "\t<ul>...</ul>") — giống $.ajax({dataType:'json'}) của bản cũ. Không có header thì trả HTML đầy đủ.
 */
export async function fetchCmsHtml(url, { signal } = {}) {
  const res = await fetch(url, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin',
    signal,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const text = await res.text();
  try {
    const parsed = JSON.parse(text);
    return typeof parsed === 'string' ? parsed : text;
  } catch (e) {
    return text;
  }
}

// Tạo DOM từ chuỗi HTML (template không chạy script, an toàn hơn innerHTML trực tiếp vào trang)
export function toFragment(html) {
  const tpl = document.createElement('template');
  tpl.innerHTML = html.trim();
  return tpl.content;
}
